import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TextEditor } from '../../ui/TextEditor';

interface Props {
  disabled?: boolean;
}

export const CityDetailsTextField: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  return (
    <TextEditor
      disabled={disabled}
      label={t('dashboard.assets.addedit.main.citydetails.fields.cityDetails.label')}
      fieldName="descriptions.cityDetails"
    />
  );
};
